import { FC } from 'react';
import { RouterConfig } from '@edikk-edikk/country-frontend';
import { Link } from 'react-router';
import { useAdvertCardContext } from '#advert/components/card';
import advertCardFooterCss from '../assets/advert-card-footer.module.scss';

const FooterName: FC = () => {
  const { advert } = useAdvertCardContext();

  return (
    <Link
      to={advert.url}
      state={{ routerConfig: RouterConfig.initForAdvertDetail(advert.id) }}
      className={advertCardFooterCss.advertCardFooter__name}
    >
      {advert.name}
    </Link>
  );
};

export { FooterName };
